import { useEffect, useMemo, useRef } from 'react';
import LogRecordComponent from '../LogRecord';
import LogRecord, {
  LogRecordType,
} from '../../../../../bridge/utils/LogRecord';
import LoadingIcons from 'react-loading-icons';

interface Props {
  id: string;
  logRecords: LogRecord[];
  isLoading: boolean;
  searchQuery?: string;
  messageTypes?: LogRecordType[];
  maxLogs: number;
}

const LogsScreen = (props: Props) => {
  const {
    id,
    logRecords,
    isLoading,
    searchQuery,
    messageTypes,
    maxLogs = 200,
  } = props;

  const scrollRef = useRef<HTMLUListElement>(null);

  const filteredLogRecords = useMemo(
    () =>
      logRecords
        .filter(
          (log) =>
            (!messageTypes || messageTypes.includes(log.type)) &&
            (!searchQuery?.length ||
              JSON.stringify(log.message).includes(searchQuery)),
        )
        .slice(-maxLogs),
    [searchQuery, messageTypes, maxLogs, logRecords],
  );

  useEffect(() => {
    scrollRef.current?.lastElementChild?.scrollIntoView();
  }, [filteredLogRecords]);

  return (
    <div
      style={{
        position: 'relative',
        paddingTop: 10,
        display: 'flex',
        flex: 1,
        overflowY: 'scroll',
      }}
    >
      <ul
        style={{
          backgroundColor: '#1c1b1b',
          borderRadius: 4,
          paddingLeft: 14,
          paddingTop: 10,
          display: 'flex',
          flex: 1,
          overflowY: 'scroll',
          flexDirection: 'column',
        }}
        ref={scrollRef}
        key={`${id}_${filteredLogRecords.length}`}
      >
        {filteredLogRecords.map((logRecord, index) => (
          <LogRecordComponent
            key={`message_${logRecord.timestamp}_${index}`}
            logRecord={logRecord}
          />
        ))}
      </ul>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            flex: 1,
            top: 5,
            right: 15,
          }}
        >
          <LoadingIcons.Grid width={30} />
        </div>
      )}
    </div>
  );
};

export default LogsScreen;
